import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    fetchCountries,
    fetchTags,
    fetchLitterReport,
    fetchLitterReportCount,
    sendRequestForm,
    sendLitterReport,
    fetchLittersForMap,
} from '../../api/index';
import {
    COUNTRIES_LIST_REQUESTED,
    TAGS_LIST_REQUESTED,
    LITTER_REPORT_REQUESTED,
    LITTER_REPORT_COUNT_REQUESTED,
    FORM_SUBMISSION_REQUESTED,
    SEND_LITTER_REPORT_REQUESTED,
} from './constants';
import {
    countriesListSucceeded,
    countriesListFailed,
    tagsListSucceeded,
    tagsListFailed,
    litterReportSucceeded,
    litterReportFailed,
    litterReportCountSucceeded,
    litterReportCountFailed,
    formSubmissionSucceeded,
    formSubmissionFailed,
    sendLitterReportFailed,
    sendLitterReportSucceeded,
    mapDataSucceeded,
    mapDataFailed,
} from './actions';
import {
    getSelectedLitterReportFilter,
    getFormDetails,
    getReportRequestDetails,
} from './selectors';
import { logException } from '../../logger';
function* fetchCountriesList() {
    try {
        const countries = yield call(fetchCountries);
        if (countries) {
            yield put(countriesListSucceeded(countries));
        }
    } catch (e) {
        logException(e);
        yield put(countriesListFailed(e));
    }
}

function* fetchTagsList() {
    try {
        const tags = yield call(fetchTags);
        if (tags) {
            yield put(tagsListSucceeded(tags));
        }
    } catch (e) {
        logException(e);
        yield put(tagsListFailed(e));
    }
}

function* fetchRequestedLitterReport() {
    try {
        const filters = yield select(getSelectedLitterReportFilter);

        // litter report params
        const params = prepareFilterParams(filters);

        const litterReport = yield call(fetchLitterReport, params);

        if (litterReport) {
            yield put(litterReportSucceeded(litterReport));
        }
    } catch (e) {
        logException(e);
        yield put(litterReportFailed(e));
    }
}

function* fetchRequestedLitterMapData() {
    try {
        const filters = yield select(getSelectedLitterReportFilter);

        // litter report params
        const params = prepareFilterParams(filters);
        const littersForMap = yield call(fetchLittersForMap, params);

        if (littersForMap) {
            yield put(mapDataSucceeded(littersForMap));
        }
    } catch (e) {
        logException(e);
        yield put(mapDataFailed(e));
    }
}

function* fetchRequestedLitterReportCount() {
    try {
        const filters = yield select(getSelectedLitterReportFilter);

        // litter report params
        const params = prepareFilterParams(filters);

        const litterReportCount = yield call(fetchLitterReportCount, params);

        if (litterReportCount) {
            yield put(litterReportCountSucceeded(litterReportCount));
        }
    } catch (e) {
        logException(e);
        yield put(litterReportCountFailed(e));
    }
}

function prepareFilterParams(filters) {
    const params = {
        countryCodes: filters.selectedCountries.map((country) => country.id),
        tagIds: filters.selectedTags.map((tag) => tag.id),
        offset: filters.offset ? filters.offset : 0,
        limit: filters.limit ? filters.limit : 5,
    };

    if (filters.selectedStartDate) {
        let startDate = new Date(filters.selectedStartDate).setSeconds(0);
        startDate = new Date(startDate).setMinutes(0);
        startDate = new Date(startDate).setHours(0);

        params.startDate = filters.selectedStartDate ? startDate : '';
    }

    if (filters.selectedEndDate) {
        let endDate = new Date(filters.selectedEndDate).setSeconds(59);
        endDate = new Date(endDate).setMinutes(59);
        endDate = new Date(endDate).setHours(23);

        params.endDate = filters.selectedEndDate ? endDate : '';
    }

    if (filters.selectedRadius) params.radius = filters.selectedRadius;

    if (filters.selectedZipcode) params.zipCity = filters.selectedZipcode;

    return params;
}

function* submitFormData() {
    try {
        const details = yield select(getFormDetails);
        const submission = yield call(sendRequestForm, details);

        if (submission === 1) {
            yield put(formSubmissionSucceeded(submission));
        } else {
            yield put(formSubmissionFailed(submission));
        }
    } catch (e) {
        logException(e);
        yield put(formSubmissionFailed(e));
    }
}

function* sendRequestedLitterReport() {
    try {
        const requestDetails = yield select(getReportRequestDetails);
        const filters = yield select(getSelectedLitterReportFilter);

        // litter report params
        const preparedFilters = prepareFilterParams(filters);

        const params = {
            ...requestDetails,
            ...preparedFilters,
        };

        // send report request
        const response = yield call(sendLitterReport, params);

        if (parseInt(response)) {
            yield put(
                sendLitterReportSucceeded([
                    'Check your inbox. Your report should arrive in your email sometime in the next few minutes. Please be sure to also check your Spam folder.',
                    'Email support@litterati.org  if you need help or have any questions.',
                ]),
            );
        } else {
            yield put(
                sendLitterReportFailed(
                    'Unable to send report, please try again in a bit.',
                ),
            );
        }
    } catch (e) {
        logException(e);
        yield put(
            sendLitterReportFailed(
                'Unable to send report, please try again in a bit.',
            ),
        );
    }
}

export default function*() {
    yield all([
        takeLatest(COUNTRIES_LIST_REQUESTED, fetchCountriesList),
        takeLatest(TAGS_LIST_REQUESTED, fetchTagsList),
        takeLatest(LITTER_REPORT_REQUESTED, fetchRequestedLitterReport),
        takeLatest(LITTER_REPORT_REQUESTED, fetchRequestedLitterMapData),
        takeLatest(
            LITTER_REPORT_COUNT_REQUESTED,
            fetchRequestedLitterReportCount,
        ),
        takeLatest(FORM_SUBMISSION_REQUESTED, submitFormData),
        takeLatest(SEND_LITTER_REPORT_REQUESTED, sendRequestedLitterReport),
    ]);
}
